import { Parameter } from "domain/entities/parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const StatusTimesheetDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [TimesheetStatusOptions, setTimesheetStatusOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { timesheetStatus, setTimesheetStatus } = useParameterStore();

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
  } as BaseInputFilter);

  useEffect(() => {
    setTimesheetStatus(
      parameters?.data?.filter((item) => item.type === "timesheetStatus")
    );
  }, [parameters]);

  useEffect(() => {
    setTimesheetStatusOptions(
      timesheetStatus.map((item: Parameter) => ({
        label: item.value,
        value: item.value,
      }))
    );
  }, [timesheetStatus]);

  return (
    <Dropdown
      value={options.value}
      options={TimesheetStatusOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o status"
      showClear
    />
  );
};
export default StatusTimesheetDropdown;
